import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSparkles } from '@fortawesome/pro-solid-svg-icons/faSparkles';

import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { Text, TextType } from 'ui-components/components/text';

import style from './cost-review-line-item-applicable-recommendation.module.less';
import { messages } from './messages';
import { DataDrivenLogo } from '../../data-driven-logo';
import { FormattedCurrency } from '../../formatted-currency';

/**
 * @param {object} props
 * @param {import('../../../prop-types/cost-review.types').CostReviewRecommendation} props.recommendation
 * @param {boolean} props.isToggleRecommendationDisabled
 * @param {(recommendationKey: string) => void} props.onToggleRecommendation
 * @returns {React.JSX.Element}
 */
export const CostReviewLineItemApplicableRecommendation = ({ recommendation, isToggleRecommendationDisabled, onToggleRecommendation }) => {
  const recommendationIcon =
    recommendation.labelProviderId || recommendation.insuranceProviderId ? (
      <DataDrivenLogo
        className={style['recommendation-icon']}
        insuranceProviderId={recommendation.insuranceProviderId}
        logoType='icon'
        providerId={recommendation.labelProviderId}
        showIcon
      />
    ) : null;

  return (
    <div className={style['recommendation-container']}>
      <div className={style['recommendation-savings']}>
        <FontAwesomeIcon className={style['savings-icon']} icon={faSparkles} />
        <Text
          className={style['recommendation-text']}
          element='span'
          formattedMessageValues={{
            savingsAmount: (
              <FormattedCurrency currencyCode={recommendation.totalSavings?.code} value={recommendation.totalSavings?.value} />
            ),
            recommendationIcon,
            recommendation: recommendation.name,
            b: (chunks) => <b>{chunks}</b>,
            span: (chunks) => <span className={style['recommendation-name-and-icon']}>{chunks}</span>,
          }}
          textType={TextType.Caption}
          value={messages.savings}
        />
      </div>
      <Button className={style['apply-button']} disabled={isToggleRecommendationDisabled} onClick={onToggleRecommendation} theme='tertiary'>
        <FormattedMessage {...messages.apply} />
      </Button>
    </div>
  );
};
